import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthGuard } from '../../services/auth-guard';

@Component({
  selector: 'login',
  templateUrl: './login.html',
  styleUrls: ['./login.css']
})
export class Login {

  key: string;
  constructor(private authGuard: AuthGuard, private router: Router) { }

  ngOnInit() {
    this.authGuard.logout();
    this.authGuard.error$.subscribe((error: any)=> {
      alert('Invalid key.');
    });

    this.authGuard.auth$.subscribe((url: string)=>{
      console.log('redirecting', url);
      window.location.href = url;
      // this.router.navigate([url]);
    });
  }

  login() {
    
    if(!this.key)
    {
        alert('Invalid key');
        return;
    }
    
    this.authGuard.login(this.key);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/login/login.ts